import { render, staticRenderFns } from "./chart-pie.vue?vue&type=template&id=51f3dc26"
import script from "./chart-pie.vue?vue&type=script&lang=js"
export * from "./chart-pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports